// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blip[data-v-50be47d7] {\n  color: rgb(var(--fc-surface-accented));\n  filter: drop-shadow(0 0 1px rgb(var(--fc-surface-accented)));\n  font-size: 0.7em;\n}\n.blip-animation[data-v-50be47d7] {\n  animation: blip-data-v-50be47d7 1s ease-in 0s;\n}\n@keyframes blip-data-v-50be47d7 {\nfrom {\n    color: rgb(246, 255, 193);\n    filter: drop-shadow(0 0 6px rgb(165, 255, 47));\n}\n}\n", ""]);
// Exports
module.exports = exports;
